<template>
  <div class="scrollbar-inner">
    <div class="card">
      <!-- Card header -->
      <div class="card-header">
        <!-- Title -->
        <h4 class="h3 mb-0">{{ title }}</h4>
      </div>
      <!-- Card search -->
      <div class="card-header py-0">
        <!-- Search form -->
        <form>
          <div class="form-group mb-0">
            <div class="input-group input-group-lg input-group-flush">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <span class="fas fa-search"></span>
                </div>
              </div>
              <input
                type="search"
                v-model="queryText"
                class="form-control"
                placeholder="Search"
                aria-label="Example text with two button addons"
                aria-describedby="button-addon3"
              />
            </div>
          </div>
        </form>
      </div>
      <!-- Card body -->
      <div class="card-body px-2 py-3">
        <!-- List group -->
        <ul class="list-group list-group-flush list my--3">
          <li class="list-group-item px-0" v-for="(user, ind) in filteredUsers" :key="ind">
                <div class="row align-items-center mx-0">
                  <div class="col-auto px-1">
                    <!-- Avatar -->
                    <a href="#" class="avatar avatar-sm rounded-circle">
                      <img v-if="user.image" alt="Image placeholder" :src="user.image" />

                      <span v-else>{{user.first_name.substring(0,1)}}</span>
                    </a>
                  </div>
                  <div class="col ml-1 px-1">
                    <h5 class="mb-0">
                      <a href="#!" class="d-block">{{user.first_name}} {{user.last_name}}</a>
                    </h5>
                    <span class="text-success">●</span>
                    <small>Online</small>
                  </div>
                  <div class="col-auto px-1">
                    <label class="custom-toggle">
                      <input
                        type="checkbox"
                        :checked="sideBarUser && (sideBarUser.id == user.id)"
                        @change="onUserSelected(user)"
                      />
                      <span
                        class="custom-toggle-slider rounded-circle"
                        data-label-off="OFF"
                        data-label-on="ON"
                      />
                    </label>
                  </div>
                </div>
              </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "SingleUserPicker",
  props:['sideBarUser', 'sidebarMode'],
  data() {
    return {
      users: [],
      queryText: "",
      title:"Assigned By"
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(res => {
        if (this.queryText != "") {
          let fullName = res.first_name.toLowerCase()+' '+res.last_name.toLowerCase()
          return fullName.includes(this.queryText.toLowerCase())
        }
        else  {
          return true;
        }
      });
    },
  },
  watch: {
    sidebarMode() {
      if(this.sidebarMode == "ASSIGN_BY") {
        this.title = "Assigned By"
      } else {
        this.title = "Assigned To"
      }

    }
  },
  mounted() {
    
    this.fetchAllUsers()
      .then(res => (this.users = res.data))
      .catch(err => {
        console.log("error fetching users");
      });
  },
  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    onUserSelected(user) {
      this.$emit('userSelected',user)
    } 
  }
};
</script>

<style lang="sass">

</style>